<template>
    <div ref="translateRef">
        <label class="th-btn th-btn-plain"
               @click="dropdown = !dropdown">
            <IconTranslate class="th-btn-icon"/>
            <span>{{$t(`Translate.${mode}`)}}</span>
            <IconArrowDown class="th-btn-icon" :class="{'rotate-180':dropdown}"/>
        </label>
        <ul class="th-menu absolute right-5 z-10 mt-1 w-52" v-show="dropdown">
            <li :class="{'th-menu-item-active': isTranslateToChinese}" @click="()=>handleClickItem(TRANSLATE_LANGUAGES_INS.CHINESE)">
                <a>{{$t('Translate.CN')}}</a>
                <IconCheck class="th-menu-item-post-icon" v-if="isTranslateToChinese"/>
            </li>
            <li :class="{'th-menu-item-active': isTranslateToEnglish}" @click="()=>handleClickItem(TRANSLATE_LANGUAGES_INS.ENGLISH)">
                <a>{{$t('Translate.EN')}}</a>
                <IconCheck class="th-menu-item-post-icon" v-if="isTranslateToEnglish"/>
            </li>
            <li :class="{'th-menu-item-active': isTranslateToJapan}" @click="()=>handleClickItem(TRANSLATE_LANGUAGES_INS.JAPANESE)">
                <a>{{$t('Translate.JP')}}</a>
                <IconCheck class="th-menu-item-post-icon" v-if="isTranslateToJapan"/>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, onBeforeUnmount } from 'vue'
import { onClickOutside } from '@vueuse/core'
import IconTranslate from '@/components/icons/IconTranslate.vue'
import IconArrowDown from '@/components/icons/IconArrowDown.vue'
import { TRANSLATE_LANGUAGES } from '@/types'
import IconCheck from '@/components/icons/IconCheck.vue'
import { useTranslate } from '@/composables/use-translate'
import { useGlobalState } from '@/composables/use-global-store'
const TRANSLATE_LANGUAGES_INS = TRANSLATE_LANGUAGES
const { inputLang } = useGlobalState();

const dropdown = ref(false)
const translateRef = ref(null)

onClickOutside(
    translateRef,
    () => {
        dropdown.value = false
    }
)

const { change, mode, isTranslateToEnglish, isTranslateToJapan, isTranslateToChinese } = useTranslate();

onMounted(() => {
    if (mode.value === TRANSLATE_LANGUAGES.NONE) {
        change(inputLang.value)
    }
})

onBeforeUnmount(() => {
    change(TRANSLATE_LANGUAGES.NONE)
})

function handleClickItem(modelValue: TRANSLATE_LANGUAGES) {
    change(modelValue)
    dropdown.value = false
}
</script>
